export default function() {
  this.setState({ signupError: undefined })
}
